// extracted by mini-css-extract-plugin
export var avatarContainer = "_b1-0";
export var avatarTypingWave = "_b1-i";
export var gray = "_b1-f";
export var green = "_b1-c";
export var icon = "_b1-9";
export var image = "_b1-1";
export var lg = "_b1-6";
export var md = "_b1-5";
export var presenceDot = "_b1-b";
export var red = "_b1-d";
export var sm = "_b1-4";
export var status = "_b1-a";
export var typingDot = "_b1-h";
export var typingPill = "_b1-g";
export var xl = "_b1-7";
export var xs = "_b1-3";
export var xxl = "_b1-8";
export var xxs = "_b1-2";
export var yellow = "_b1-e";